import { render, staticRenderFns } from "./MultiDeviceLegend.vue?vue&type=template&id=1e64b7e4&"
import script from "./MultiDeviceLegend.vue?vue&type=script&lang=js&"
export * from "./MultiDeviceLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports